import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { map, Observable } from 'rxjs';
import { ApplicationRating, FeedbackRequired } from '../types/feedback/feedback.types';

@Injectable({
  providedIn: 'root',
})
export class FeedbackService {
  private readonly http = inject(HttpClient);
  private readonly url = `${environment.url.api}/feedback`;

  sendWeekFeedback(score: number): Observable<void> {
    return this.http.post<void>(`${this.url}/me/week`, { score });
  }

  sendApplicationFeedback(rating: ApplicationRating, feedback?: string): Observable<void> {
    return this.http.post<void>(`${this.url}/me/application`, { rating, feedback });
  }

  checkFeedback(): Observable<FeedbackRequired> {
    return this.http
      .get<FeedbackRequiredResponse>(`${this.url}/me/config`)
      .pipe(map((config) => config?.feedbackRequired));
  }
}

interface FeedbackRequiredResponse {
  feedbackRequired: FeedbackRequired;
}
